import {
  Event as AmplitudeEvent,
  EnrichmentPlugin,
} from '@amplitude/analytics-types';

export class AmplitudePlatformPlugin implements EnrichmentPlugin {
  name = 'platform-plugin';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type = 'enrichment' as any;

  async execute(event: AmplitudeEvent): Promise<AmplitudeEvent> {
    event.event_properties = {
      ...event.event_properties,
      platform: 'web',
    };
    return event;
  }
}
